
<lib-chip-button
    #chipButton
    [ngClass]="{'d-none': loading, 'd-flex': !loading}"
    [menuTrigger]="isMobile ? null : menuTrigger"
    [hasCarretSuffix]="true"
    [qaTag]="qaTag ? qaTag + '-chip-button': ''"
    (click)="DateSelectClicked()">
    <lib-icon *ngIf="!singleDaySelected" class="color-brand" [icon]="Icon.Calendar.CalendarMonth"></lib-icon>
    <lib-icon *ngIf="singleDaySelected" class="color-brand" [icon]="Icon.Calendar.CalendarToday"></lib-icon>
    <p class="typography-label-large px-1 base-300">
        <ng-container *ngIf="currentSelection && startDateISO && endDateISO">
            {{currentSelection.Label}}
        </ng-container>
        <ng-container *ngIf="!currentSelection && !startDateISO && !endDateISO" i18n="@@CommonSelectPlaceholder">
            Select...
        </ng-container>
        <ng-container *ngIf="!singleDaySelected && !currentSelection && startDateISO && endDateISO">
            {{startDateISO | formatDate:'short'}} – {{endDateISO | formatDate:'short'}}
        </ng-container>
        <ng-container *ngIf="singleDaySelected && !currentSelection && startDateISO && endDateISO">
            {{startDateISO | formatDate:'short'}}
        </ng-container>
    </p>
</lib-chip-button>

<mat-menu #menuTrigger="matMenu" yPosition="below" class="chip-date-range-select" [overlapTrigger]="false" (closed)="PanelClosed()"
	backdropClass="mat-menu-custom-backdrop">
    <lib-chip-date-range-select-panel
        [dateOptions]="dateOptions"
        [resetDateRange]="resetDateRange"
        [startDate]="startSBDate"
        [endDate]="endSBDate"
        (dateChange)="UpdateStartEndDate($event)"
        (closeMenu)="CloseMenu()"
        (menuSelectionChanged)="MenuSelectionChanged($event)">
    </lib-chip-date-range-select-panel>
</mat-menu>
